const hideElement = (element: HTMLElement) => {
    element.ariaHidden = "true";
    // element.tabIndex = -1;
    element.classList.add('d-none');
}

const showElement = (element: HTMLElement) => {
    element.ariaHidden = "false";
    // element.tabIndex = null;
    element.classList.remove('d-none')
}

const debounce = (fn: () => any, timeout = 500) => {
    let timer: number;

    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, timeout)
    }
}

export {
    showElement, hideElement, debounce
}